import './style.css';
import { initGSAPAnimations } from './js/gsapAnimations.js';
import { initVerdictSimulator } from './js/verdictSimulator.js';
import { initAnimatedAccordions } from './js/accordion.js';
import { initLiveAnalyzer } from './js/liveAnalyzer.js';
import { initHowItWorks } from './js/howItWorks.js';

document.addEventListener('DOMContentLoaded', () => {
  // 1. Load Choreography & Motion
  initGSAPAnimations();

  // 2. Sample Reference Verdict Simulator & 3D HUD Updates
  initVerdictSimulator();

  // 3. Smooth Animated Accordions
  initAnimatedAccordions();

  // 4. Live Interactive Watch URL AI Due-Diligence Inspector
  initLiveAnalyzer();

  // 5. How It Works Sticky Window Step Morphing
  initHowItWorks();

  // 6. Access Form Handler
  const accessForm = document.getElementById('access-form');
  const formSuccess = document.getElementById('form-success');

  if (accessForm) {
    accessForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const emailInput = document.getElementById('email-input');
      if (emailInput && emailInput.value) {
        accessForm.style.display = 'none';
        if (formSuccess) formSuccess.style.display = 'block';
      }
    });
  }
});
